export default __webpack_public_path__ + "static/four-pack-front-cf0dd13e8cbd04c5ac672031541797d9.png";